import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  ProjectContext,
  ProjectDispatchContext,
} from "../../contexts/ProjectContext.tsx";
import { convertProjectToProjectContext } from "../../models/Project.ts";
import { projectsPrefix } from "../ProjectsServices.ts";
import { useFetch } from "./useFetch.ts";

export enum RefreshType {
  FULL,
  ATTRIBUTE_TYPES,
}

export function useProjectRefresh() {
  const { id } = useContext(ProjectContext) || {};
  const dispatch = useContext(ProjectDispatchContext);
  const { fetch: fetchProject } = useFetch<undefined, undefined, Project>();
  const { fetch: fetchProjectAttributes } = useFetch<PatientAttributeType[]>();
  const navigate = useNavigate();

  function refreshProject(
    type: RefreshType = RefreshType.FULL,
    navigateTo?: string,
  ) {
    if (id) {
      switch (type) {
        case RefreshType.ATTRIBUTE_TYPES:
          void fetchProjectAttributes(
            `${projectsPrefix}/${id}/attributetypes`,
            {
              postResponseAction: (data) => {
                dispatch({ type: "update", project: { attributeTypes: data } });
                if (navigateTo) {
                  navigate(navigateTo);
                }
              },
            },
          );
          return;
        case RefreshType.FULL:
        default:
          void fetchProject(`${projectsPrefix}/${id}`, {
            responseManipulationFunction: (data) => {
              convertProjectToProjectContext(data, dispatch);
              return;
            },
            postResponseAction: () => {
              if (navigateTo) {
                navigate(navigateTo);
              }
            },
          });
          return;
      }
    }
  }

  return {
    refreshProject,
  };
}
